import React, { useRef } from 'react';
import { useState, useEffect } from 'react';
import Table from '../Table/Table';
import { Tables, Checkbox, Input, InputChange } from '@ixyberfree/ixybercomponents';
import './alarm.css';

interface IAlarm {
    visible?: boolean;
}

function SystemAlarmMessage(props: IAlarm) {
    const tabAlarmRef = useRef<HTMLDivElement>(null);

    const [data, setData] = React.useState<any>([]);

    const buttonData = [
        { label: 'Print', id: 'menutopbutprint', className: 'button-style print' },
        {
            label: 'Acknowledge',
            id: 'menutopbutack',
            className: 'button-style ack',
            onClick: (event: React.MouseEvent<HTMLButtonElement>) => {
                const ActiveEvents = window.Base.Events.GetActiveEvents().CentumVP.SA.Messages;
                const ids = [];
                for (const activeElement of ActiveEvents) {
                    let hasAck = ((activeElement.NewState >> 2) & 1) == 1;
                    if (hasAck) ids.push(activeElement.id);
                }
                if (ids.length != 0) window.Base.Events.AckEvents(ids);
            }
        },
        {
            label: 'Delete',
            id: 'menutopbutcross',
            className: 'button-style cross',
            onClick: (event: React.MouseEvent<HTMLButtonElement>) => {
                const ActiveEvents = window.Base.Events.GetActiveEvents().CentumVP.SA.Messages;
                const ids = [];
                for (const activeElement of ActiveEvents) {
                    const hasAck = ((activeElement.NewState >> 2) & 1) == 1;
                    if (!hasAck) ids.push(activeElement.id);
                }
                if (ids.length != 0) window.Base.Events.RemoveEvents(ids);
            }
        },
        { label: 'System Status', id: 'menutopbutunstatus', className: 'button-style system-status' },
        { label: 'Help', id: 'menutopbuthelp', className: 'button-style help' },
        { label: 'Stop/Resume', id: 'menutopbutpause', className: 'button-style stop-resume' },
        { label: 'Filter', id: 'menutopbutfilter', className: 'button-style filter' },
        { label: 'Windows Setup', id: 'menutopbutwindows', className: 'button-style windows-setup' },
        { label: 'SCS Alarm', id: 'menutopbutscs', className: 'button-style scs-alarm' }
    ];

    useEffect(() => {
        const intervalId = setInterval(() => {
            let ActiveEvents = window.Base.Events.GetActiveEvents().CentumVP.SA.Messages;
            setData(ActiveEvents);
        }, 1000);
        return () => clearInterval(intervalId);
    }, []);

    return (
        <div className={`alarm`} style={{ width: '100%', height: '100%' }}>
            <div className={`alarm__tab`} ref={tabAlarmRef}>
                {buttonData.map(({ label, id, className, onClick }) => (
                    <button
                        key={id}
                        id={id}
                        className={className}
                        onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                            if (onClick) {
                                onClick(event);
                            }
                        }}></button>
                ))}
            </div>
            <div className={`alarm__table`} style={{ width: 'calc(100% - 12px)', height: 'calc(100% - 50px)' }}>
                <Table
                    header={[
                        {
                            type: 'element',
                            width: '30px',
                            label: '',
                            idCol: 'selectRow',
                            action: false
                        },
                        {
                            type: 'number',
                            width: '50px',
                            label: '',
                            idCol: 'indexNumber',
                            action: false
                        },
                        {
                            type: 'element',
                            width: '25px',
                            label: '',
                            idCol: 'alarm',
                            action: false
                        },
                        {
                            type: 'text',
                            width: '60px',
                            label: '',
                            idCol: 'date',
                            action: false
                        },
                        {
                            type: 'text',
                            width: '130px',
                            label: '',
                            idCol: 'time',
                            action: false
                        },
                        {
                            type: 'text',
                            width: '150px',
                            label: '',
                            idCol: 'folder',
                            action: false
                        },
                        {
                            type: 'text',
                            width: '350px',
                            label: '',
                            idCol: 'error',
                            action: false
                        }
                    ]}
                    data={data}
                    width="100%"
                    height="100%"
                    paging={true}
                />
            </div>
        </div>
    );
}

export default SystemAlarmMessage;
